import Image from "next/image"
import Link from "next/link"

interface GetAppButtonsProps {
  justifyContent?: string
}

export default function GetAppButtons({ justifyContent = "justify-center" }: GetAppButtonsProps) {
  return (
    <div className={`flex flex-wrap ${justifyContent} gap-4`}>
      <Link href="https://apps.apple.com/nl/app/goodshift/id1573545734" target="blank">
        <Image
          className="w-full h-full"
          src="/goodshift/img/banners/apple_badge.svg"
          width={300}
          height={101}
          priority
          alt="apple store badge"
        />
      </Link>
      <Link href="https://play.google.com/store/apps/details?id=foundation.goodplace.app" target="blank">
        <Image
          className="w-full h-full"
          src="/goodshift/img/banners/google_badge.svg"
          width={336}
          height={101}
          priority
          alt="google store badge"
        />
      </Link>
    </div>
  )
}
